<template>
  <lego-modal
    ref="modal"
    :title="$t('page.dashboard.widgetCopy')"
    :size="704"
    @closed="pageOnCLosed"
  >
    <div class="lineContainer">
      <div class="lineTitle">
        {{ $t('page.dashboard.widgetName') }}
        <span class="required">*</span>
      </div>
      <div class="inputBox">
        <div>
          <lego-text-field
            v-model="name"
            ref="name"
            :rules="validateRule"
            :guide="$t('label.placeholder')"
            width="460"
            :counter="100"
            @blur="onBlur"
            showCounter
          />
        </div>
      </div>
    </div>

    <!-- 하단버튼 -->
    <template #action>
      <lego-button medium @click="pageOnCLosed">{{ $t('button.cancel') }}</lego-button>
      <lego-button medium main @click="onConfirm" :disabled="isDisabledConfirm">{{ $t('button.confirm') }}</lego-button>
      <!--lego-button medium main :disabled="this.config.chartAttr.subtitle === this.name" @click="onConfirm">{{$t('button.confirm')}}</lego-button -->
    </template>
  </lego-modal>
</template>
<script>
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  props: ['config'],
  mixins: [i18nMixin],
  emits: ['copyWidget', 'close'],
  data() {
    return {
      name: this.config.chartAttr.title.slice(0, 95) + this.$t('page.dashboard.copy'), // 위젯명
      validateRule: [this.checkWidgetName]
    };
  },
  computed: {
    isDisabledConfirm() {
      if (!this.name.length || this.name.charAt(0) === '.') return true;
      return this.$util.requireInputCommon(this.name);
    }
  },
  mounted() {
    this.$refs['modal'].open();
  },
  methods: {
    /*************
     * page
     *************/
    checkWidgetName(value) {
      if (this.$util.isEmpty(value)) {
        return this.$t('message.requiredInput');
      }
      if (value.length > 100) {
        return this.$t('page.dashboard.widgetNameLimit');
      }
      if (value.charAt(0) === '.') {
        return this.$t('message.preventDotCharacter');
      }
      if (this.$util.requireInputCommon(value)) {
        return this.$t('message.errorValidateInput');
      }
      return true;
    },
    onBlur() {
      this.name = this.name.trim();
      this.$refs.name.validate();
      this.$nextTick(() => {
        this.name = this.name.trim();
        this.$refs.name.validate();
      });
    },
    pageOnCLosed() {
      this.$emit('close');
    },
    onConfirm() {
      if (!this.$util.validate([this.$refs.name])) return false;
      const config = this.$util.deepCopy(this.config);
      //config.chartAttr.subtitle = this.name;
      config.chartAttr.title = this.name;
      this.$emit('copyWidget', config);
      this.$emit('close');
    }
  }
};
</script>
<style lang="scss" scoped>
.lineContainer {
  display: flex;
  margin-top: 10px;

  .lineTitle {
    width: 120px;
    font-family: $lego__font-family;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: var(--dark);
    margin-top: 7px;
  }

  .required {
    font-family: $lego__font-family;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #f00;
  }

  .inputBox {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;

    & > :first-child {
      position: relative;
    }
  }

  .subtext {
    width: 25px;
    height: 18px;
    font-family: $lego__font-family;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: right;
    color: var(--color-ui-06);
  }
}
</style>
